import { Component, OnInit, ViewChild } from '@angular/core';
import { NameComponent, TitleService } from '../names';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FormSettingsService } from '../../shared/form.settings.service';
import { CallCenterReservationService, CallData, TotalData } from '../../call-center/call-center-reservation';
import { PatientParms, SharedDateService, UserSessionService } from '../../shared';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { OutPatReservationService } from '../../outpatient/out-pat-appointment/out-pat-reservation/out-pat-reservation.service';
import { IPromotionsMsgLog } from '../../promotions/promotions';
import { SmsService } from '../../promotions/SmsService/Sms.service';
import { TitleCodes } from '../../hospitalSetup/titles-codes';

@Component({
  selector: 'app-simple-call-center-patient-reservation',
  templateUrl: './simple-call-center-patient-reservation.component.html',
  styleUrls: ['./simple-call-center-patient-reservation.component.css']
})
export class SimpleCallCenterPatientReservationComponent implements OnInit {
  @ViewChild('name') nameComponent: NameComponent;
  patReservationForm: UntypedFormGroup;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  mobileCountry = require("setting/country_1.json");
  patReservationParams: any = {};
  titleCodeList: TitleCodes[] = [];

  constructor(private _fb: UntypedFormBuilder,
    private _formServiceSettings: FormSettingsService,
    private _sharedDateService: SharedDateService,
    private _callCenterReservationService: OutPatReservationService,
    private _SmsService: SmsService,
    private _USS: UserSessionService,
    private _titlesService: TitleService,



  ) { }
  matrixData
  ngOnInit() {
    this.getModuleSettings();
    if (this._USS.getSessionKey('MatrixSessionData')) {
      this.matrixData = this._USS.getSessionKey<any>('MatrixSessionData');
      this.matrixData.reservationDate = this.matrixData.startTimeSlot;
      console.log('_____________ this.matrixData')
      console.log(this.matrixData);
    }
    this.getTitleCode();
    this.initlizeControls();
  }
  initlizeControls() {
    this.patReservationForm = this._fb.group({
      code: 0,
      dateHijri: new Date(),
      customCode: [''],
      oldCode: '',
      fname: '',
      sname: '',
      tname: '',
      lname: '',
      titleCode:'',
      name: this._fb.group({}),
      therapeuticCards: this._fb.group({}),
      address: this._fb.group({}),
      identity: this._fb.group({}),
      gender: null,
      birthDateNgb: null,
      birthPlace: [''],
      homePhone: '',
      mailAddress: [''],
      mobile2: [''],
      fatherName: '',
      motherName: '',
      nickName: '',
      parentId: '',
      employeeId: '',
      fileNo: '',
      religionId: [''],
      maritalStatus: [''],
      bloodGroup: '',
      rhValue: '',
      stopFlag: '',
      vipFlag: '',
      mortaliyFlag: '',
      mortalityDate: '',
      vipLevel: '',
      dateHijriNgb: null,
      mortalityDateNgb: null,
      placeCode: '',
      startDateNgb: '',
      ngbDayStartHoure: '',
      reservationDate: this.matrixData.startTimeSlot,
      callerName: '',
      callerPhone: '',
      callerAddress: '',
      nationalityId: '',
      callNotes: [''],
      callSort: [''],
      callReason: 3,
      callResult: [''],
      specialization: [''],
      howToReachUs: null,
      branchAddress: null,
      reservationType: 2,
      callmethod: 1,
      serviceCode: '',
      serviceName: '',
      visitSerial: '',
      approxAge: '',
      patCode: '',
      patientServiceLevelOne: '',
      patientServiceLevelTwo: '',
      patientServiceLevelThree: '',
      expectedDate: this.matrixData.startTimeSlot,
      doctorID: this.matrixData.resourceId,
      cost: '',
      leadType: 1,
      clientCode: '',
      docId: this.matrixData.resourceId,
      anesthesiologist: '',
      clinicCode: '',
      serial: 0,
      previousPatient: '',
      customerId: '',
      secoundMobile: '',
      device: '',
      mobile: ['', Validators.compose([
        Validators.required,
        Validators.pattern(new RegExp(this.mobileCountry.countries[0].regex))

      ])],
    });
  }
  private getTitleCode() {
    this._titlesService.getTitles()
      .subscribe(res => {

        this.titleCodeList = res.data.data;
      },
        err => console.error(err),
        () => {

          this.titleCodeList = this.titleCodeList.filter(t => {

            return t.fitToFlag == 'E' || t.fitToFlag == 'P-E'
          })
        })
  }

  calcage(e: any) {
    let dob_date = new Date()
    let f = (dob_date.getFullYear() - e.year);
    this.patReservationForm.get('approxAge').setValue(f);
  }

  /////////////////////get higri date #ibrahim from gregorian date
  getHigriDate() {
    this.callData.birthDateNgb = this._sharedDateService.convertFromNgBsToDate(
      this.patReservationForm.get('birthDateNgb').value
    )
  }

  onMobileKeyUp() {
    let jsonEmpFormSetup
    let mobValue
    mobValue = this.patReservationForm.get('mobile').value
    jsonEmpFormSetup = this._formServiceSettings.getFormJsonObj()

    if (jsonEmpFormSetup['mobile']['max_length'] < ((this.patReservationForm.get('mobile').value).length)) {
      this.patReservationForm.get('mobile').setValue(null)
    }
    else {
      this.patReservationForm.get('mobile').setValue(mobValue)
      ///open Modal Of Similar Data
      // this.searchSimilarDate(mobValue, 'mobile');
    }

  }
  patnum: number = 1;
  callMainDataArr = [];
  getCallData() {
    this.callData.serial = -1
    this.callData.anesthesiologist = null;
    this.callData.serviceCode = null;
    this.callData.callTypeFalg = 1
    this.callData.cCCallBeneficiarySerial = null
    this.callData.patCode = null;
    this.callData.callTypeFalg = 1
    this.callData.specialization = null;
    this.callData.clinicCode = null;
    this.callData.expectedStartTime = this.matrixData.startTimeSlot;
    this.callData.expectedEndTime = this.matrixData.endTimeSlot;
    this.callData.minutesPerSlot = 15;
    this.callData.address = null;
    this.callData.callerName = this.patReservationForm.value.callerName;
    this.callData.phoneNumber = this.patReservationForm.value.callerPhone ? this.patReservationForm.value.callerPhone : this.patReservationForm.value.mobile;
    this.callData.secoundMobile = null;
    this.callData.notes = null;
    this.callData.callSort = 1;
    this.callData.callReason = 3;
    this.callData.callResult = null;
    this.callData.reservationType = 1;
    this.callData.callmethod = 1;
    this.callData.reservationDate = this.matrixData.startTimeSlot;
    this.callData.device = null;
    this.callData.docId = this.matrixData.resourceId
  }

  getPatientFromForm(): any {
    let dummy = <any>(this.patReservationForm.value);
    let formValue = Object.assign({}, dummy);
    formValue.code = formValue.code ? formValue.code : 0;
    formValue.titleCode = this.nameComponent.nameForm.get('titleCode').value;
    formValue.fnameAr = this.nameComponent.nameForm.get('fnameAr').value;
    formValue.fnameEn = this.nameComponent.nameForm.get('fnameEn').value;
    formValue.snameAr = this.nameComponent.nameForm.get('snameAr').value;
    formValue.snameEn = this.nameComponent.nameForm.get('snameEn').value;
    formValue.tnameAr = this.nameComponent.nameForm.get('tnameAr').value;
    formValue.tnameEn = this.nameComponent.nameForm.get('tnameEn').value;
    formValue.lnameAr = this.nameComponent.nameForm.get('lnameAr').value;
    formValue.lnameEn = this.nameComponent.nameForm.get('lnameEn').value;
    formValue.fullnameAr = formValue.fnameAr + ' ' + formValue.snameAr + ' ' + formValue.tnameAr + ' ' + formValue.lnameAr;
    formValue.fullnameEn = formValue.fullnameAr;
    this.callData.callerName = formValue.fullnameAr;
    formValue.mobile = formValue.mobile;
    formValue.patExpectedFlag = 0
    formValue.expectedDate = this._sharedDateService.convertFromNgBsToDate(formValue.expectedDate)
    console.log('***********formValue*****formValue', formValue)
    return formValue;
  }
  callData: CallData = <CallData>{};
  patientParms: PatientParms[];
  resetForm() {
    this.patReservationForm.reset();
    this._USS.removeSessionKey('MatrixSessionData');
  }
  mark_Leads: any = {};
  savePatientReservation() {
    for (var i = 0; i < this.patnum; i++) {
      this.callMainDataArr[i] = this.getPatientFromForm();
    }
    this.getCallData();
    this.mark_Leads.doctorID = this.matrixData.resourceId;
    this.mark_Leads.leadType = 1
    this.mark_Leads.expectedDate = new Date();
    this.mark_Leads.discountType = 0;
    let patientdata = <TotalData>{
      callMainData: this.callMainDataArr,
      therapeuticCards: null,
      callData: this.callData ? this.callData : null,
      mark_Leads: this.mark_Leads
    };

    this._callCenterReservationService.addCallerData(patientdata)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(c => {
        if (c["returnFlag"]) {
          if (c.data && c.data.length > 0) {
          //  this._USS.setSessionKey("CUSTOMERSERIAL", c.data[0].serial)
          }
          //send sms message in reservation
          //reservation&reservationDone&clinic
          if (this.sendMessageFlag) {
            this.callDataSerial = c.data[0].serial
            this.saveMessagesLog()
          }
          this.resetForm();

        }
      },
        err => console.log(err),
        () => {

        });
    console.log("patientdata = ", patientdata);
  }
  callDataSerial: number
  messagesLog: IPromotionsMsgLog = <IPromotionsMsgLog>{};
  msgTemplateData: any
  sendMessageFlag: boolean = false;
  exisitedPatFalg: boolean = false;
  //data of sms message
  saveMessagesLog() {
    //get template message
    if (this.msgTemplateData) {
      if (this.msgTemplateData.smsTemplate) {
        //create message
        this.replacrDatainSms()
        this.messagesLog.serial = -1
        this.messagesLog.patCode = this.exisitedPatFalg ? this.callData.patCode : null;
        this.messagesLog.message = this.msgTemplateData.smsTemplate
        this.messagesLog.sentDate = new Date()
        this.messagesLog.sender = +JSON.parse(sessionStorage.getItem('currentUser')).userID
        this.messagesLog.mobile = this.patReservationForm.value.callerPhone ? this.patReservationForm.value.callerPhone : this.patReservationForm.value.mobile;;
        this.messagesLog.callDataSerial = this.callDataSerial
        this.messagesLog.messageType = 3 //رساله تاكيد حجز مريض
        this._SmsService.RemindingBookingMsg([this.messagesLog])
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(res => {
            if (res && res.returnFlag) {

            }
          })


      }
    }
  }
  replacrDatainSms() {
    //let SmsData:any
    let SmsData = <any>{
      reservationDate: this.matrixData.startTimeSlot,
      doctorName: this.matrixData.resourceId
    };
    this.msgTemplateData.smsTemplate = this._SmsService.replaceSmSMsgData(SmsData, this.templateMsg)
    console.log(this.msgTemplateData.smsTemplate)

  }
  getModuleSettings() {
    this._callCenterReservationService.getStockModuleSettings({ moduleId: 10123 })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(c => {

        if (c.data && c.data.length > 0) {
          if (c.data[0])
            this.sendMessageFlag = +c.data[0]['sendMsgFlag'] == 1 ? true : false;
        }
      });
  }
  templateMsg: string = '';
  msgTemplate: any;
  hideSendMessageBox: any;
  getMsgTemplate() {
    this.msgTemplate.fieldName = 'reservationPatientSMS'
    this.msgTemplate.reservationDate = this._sharedDateService.convertFromNgBsToDate(this.matrixData.startTimeSlot);
    this.msgTemplate.specialityId = 0;
    this.msgTemplate.empId = this.matrixData.resourceId
    this._SmsService.getMsgTemplate(this.msgTemplate)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          if (res && res.data) {
            this.msgTemplateData = res.data[0];
            this.templateMsg = this.msgTemplateData.smsTemplate
            this.hideSendMessageBox = this.msgTemplateData.sendSmsFlag
          }
        }
      )
  }
  
}
